var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { computedFrom } from "aurelia-binding";
import { NotifyPropertyChangedBase, Reflection } from "../../../utilities/reflection";
import { AdornerService } from "../../../services/basics/adorner-service";
import { autoinject, transient } from "aurelia-dependency-injection";
var Adorner = /** @class */ (function () {
    function Adorner(adornerService) {
        var _this = this;
        this.models = [];
        adornerService.onAdd(function (model) {
            if (model.context && model.element && model.html) {
                _this.models.push(model);
            }
        });
        adornerService.onRemove(function (model) {
            var index = _this.models.indexOf(model);
            if (index >= 0) {
                _this.models.splice(index, 1);
            }
        });
        setInterval(function () {
            var e_1, _a;
            try {
                for (var _b = __values(_this.models), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    if (item.top != item.oldTop) {
                        item.onPropertyChanged(function (x) { return x.top; });
                        item.oldTop = item.top;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }, 10);
    }
    Adorner = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [AdornerService])
    ], Adorner);
    return Adorner;
}());
export { Adorner };
var AdornerModel = /** @class */ (function (_super) {
    __extends(AdornerModel, _super);
    function AdornerModel(context, html, element) {
        var _this = _super.call(this) || this;
        _this.context = context;
        _this.html = html;
        _this.element = element;
        return _this;
    }
    Object.defineProperty(AdornerModel.prototype, "top", {
        get: function () {
            var dropdownHeight = this.reference ? ($(this.element).offset().top + $(this.reference).outerHeight()) : 0;
            var top = this.element ? $(this.element).offset().top : 0;
            if (this.reference && dropdownHeight > $("body").height()) {
                return (top - $(this.reference).outerHeight()) - $(this.element).parent().outerHeight();
            }
            return top;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdornerModel.prototype, "left", {
        get: function () {
            return this.element ? this.element.getBoundingClientRect().left : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdornerModel.prototype, "width", {
        get: function () {
            return this.element ? this.element.getBoundingClientRect().width : 0;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.changes.top; })),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], AdornerModel.prototype, "top", null);
    return AdornerModel;
}(NotifyPropertyChangedBase));
export { AdornerModel };
